/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StepLogDetailDto { 
    id?: string;
    instanceId?: string;
    nodeId?: string;
    moduleId?: string;
    status?: StepLogDetailDto.StatusEnum;
    correlationId?: string;
    startedAt?: Date;
    scheduledFor?: Date;
    completedAt?: Date;
    durationMs?: number;
    ruleId?: string;
    ruleName?: string;
    fileId?: string;
    fileName?: string;
    statusMessage?: string;
    errorMessage?: string;
    inputData?: { [key: string]: any; };
    inputPreview?: string;
    inputTruncated?: boolean;
    inputChars?: number;
    outputData?: { [key: string]: any; };
    outputPreview?: string;
    outputTruncated?: boolean;
    outputChars?: number;
    logs?: Array<any>;
    logsTruncated?: boolean;
    aiModel?: string;
    aiModelDeployment?: string;
    aiInputTokens?: number;
    aiOutputTokens?: number;
    aiTotalTokens?: number;
}
export namespace StepLogDetailDto {
    export type StatusEnum = 'PENDING' | 'RUNNING' | 'AWAITING_INPUT' | 'COMPLETED' | 'FAILED' | 'SKIPPED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        AWAITINGINPUT: 'AWAITING_INPUT' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        SKIPPED: 'SKIPPED' as StatusEnum
    };
}